import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Card, CardActionArea, CardContent, Typography, Box } from '@material-ui/core';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import BuildIcon from '@material-ui/icons/Build';
import SchoolIcon from '@material-ui/icons/School';
import ChatIcon from '@material-ui/icons/Chat';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[8],
    },
  },
  cardAction: {
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  iconBox: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 28,
    color: theme.palette.common.white,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
}));

interface QuickLink {
  title: string;
  description: string;
  icon: React.ReactNode;
  href: string;
  color: string;
}

const quickLinks: QuickLink[] = [
  {
    title: 'Resources',
    description: 'Guides and tutorials',
    icon: <MenuBookIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/resources/',
    color: '#3b82f6',
  },
  {
    title: 'AI Tools',
    description: 'MCP servers and utilities',
    icon: <BuildIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/guides/tools-overview/',
    color: '#10b981',
  },
  {
    title: 'Getting Started',
    description: 'Begin your AI journey',
    icon: <SchoolIcon />,
    href: '/docs/default/component/avid-developer-portal/ai-central/guides/getting-started/',
    color: '#f59e0b',
  },
  {
    title: 'AI Assistant',
    description: 'Chat with our AI helper',
    icon: <ChatIcon />,
    href: '/ai-assistant',
    color: '#8b5cf6',
  },
];

export const QuickLinksGrid = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {quickLinks.map(link => (
        <Grid item xs={6} sm={3} key={link.title}>
          <Card className={classes.card}>
            <CardActionArea
              className={classes.cardAction}
              component={Link}
              to={link.href}
            >
              <CardContent className={classes.content}>
                <Box
                  className={classes.iconBox}
                  style={{ backgroundColor: link.color }}
                >
                  {React.cloneElement(link.icon as React.ReactElement, {
                    className: classes.icon,
                  })}
                </Box>
                <Typography variant="subtitle1" className={classes.title}>
                  {link.title}
                </Typography>
                <Typography className={classes.description}>
                  {link.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
